export let deliveryCharge = 0

export const setDeliveryCharge = (value: number) => {
  deliveryCharge = value
}